module.exports = __webpack_public_path__ + "static/media/card-Discover.daba4867.svg";